<template>


        <div class="tab-keys" style="height: calc(100% - 125px);">
            <!-- <div class="tab">
                <ul>
                    <li class="check">快捷键设置</li>
                    <li></li>
                </ul>
                
            </div>  -->

            <div class="content-box" style="padding-bottom:20px">
                <div class="setup_title"><i></i>系统快捷键</div>
                <div class="setup_content">
                    <div class="setup_keybox" v-for="(system,index) in systemKey" :key="index">
                        <div class="setup_keylable">{{system.text}}</div>
                        <div class="setup_keyblock">
                            <hotkey-input :hotkey.sync="system.Shortcutkey" placeholder="请输入按键"></hotkey-input>
                        </div>
                    </div>
                    
                </div>

                <div v-if="actionList.length>0">
                    <div class="setup_title"><i></i>动画快捷键</div>
                    <div class="setup_content action">
                        <div class="setup_keybox" v-for="(action,index) in actionList" :key="index">
                            <div class="setup_keylable" @click="playModelAnimation(action.key)">{{action.remark}}：</div>
                            <div class="setup_keyblock">
                                <hotkey-input :hotkey.sync="action.Shortcutkey" placeholder="请输入按键"></hotkey-input>
                            </div>
                        </div>
                        
                    </div>

                    <!-- <div class="save_role" @click="saveKeys">保存</div> -->
                    
                </div>
            </div>
            <div class="savebtn" @click="saveKeys"><span class="confirmbtn">保存</span></div>
        </div>


</template>
<script>


import {localData} from  '@/components/util/util_fun.js'
import hotkeyInput from '@/components/HotKeyInput'
import {UserCommon} from '@/components/other/UserCommon.js'
export default {
    props:['modelClass','user'],
    name: 'Catch',
    components:{
        hotkeyInput
    },
    data(){
        return {
            keyList:[],//零时存放所有已存在的快捷键，方便销毁
            actionList:[],//动作列表
            systemKey:[ //系统设置的key
                {key:"showOrHideMenu",text:"展示隐藏菜单",Shortcutkey:[]},
                {key:"openOrCloseFace",text:"开启关闭面捕",Shortcutkey:[]},
            ],
            saveLoading:false,
        }
    },
    created(){

        //从角色信息里读取信息
        if(this.user.param!=""&&this.user.param!=undefined&&this.user.param!=null&&this.user.param.length>0){
            var param =  JSON.parse(this.user.param)

            //动作
            if(param.action!=undefined&&param.action!=null&&param.action.length>0){
                param.action.forEach(function(action,index){
                    if(action.Shortcutkey==undefined||action.Shortcutkey==null||action.Shortcutkey==""){
                        action.Shortcutkey=[];
                    }
                })
                this.actionList  = param.action;
            }else{
                this.getAction()
            }

            //系统设置
            if(param.systemKey!=undefined&&param.systemKey!=null&&param.systemKey.length>0){
                this.systemKey=param.systemKey;
            }
        
        //没有的话就从新获取
        }else {
            this.getAction()
        }
    },
    mounted () {

      
    },

   
    methods:{
       
        //初始化参数
        init(){
            
            
        },

        // 获取动作列表
        getAction(){
            
            var action =  this.modelClass.getModelAnimation()
            if(this.user.type==1){
                action.animationNames.forEach(i=>{
                    this.actionList.push({key:i,preview:'',remark:i,Shortcutkey:[],show:false}) 
                })
            }else {
                 action.forEach((value,key)=>{
                
                    this.actionList.push({key:key,preview:'',remark:key,Shortcutkey:[],show:false}) 
                });
            }
           
        },

        //播放动画的方法
        playModelAnimation(actionKey){
            this.modelClass.playAnimation(actionKey);
        },

        //保存的方法
        saveKeys(){
            console.log(this.actionList)
            this.saveKeysToParam();
        },

        //保存到数据库
        saveKeysToParam(){
            console.log('save')
            if(this.saveLoading){
                return;
            }

            var param={
                action:[],//动作快捷键
                systemKey:[],//系统快捷键
            }
            if(this.user.param!=undefined&&this.user.param!=null){
                param =  JSON.parse(this.user.param);
            }
            param.action=this.actionList;
            param.systemKey=this.systemKey;

            this.user.param = JSON.stringify(param)
            this.user.uid=this.$store.state.userinfo.userId;

            this.saveLoading=true;
         
            // UserCommon.saveUser(this.user,true)
            // this.$emit("success",param)
            var that=this;
            this.post("/roles/editModel",this.user).then((res)=>{
                if (res.status == "200") {
                     that.$message.success("保存成功")
                     that.$emit("success",param)
                     localData("set","historyHodel_"+that.$store.state.userinfo.userId,that.user)
                }else{
                     that.$message.error("保存失败")
                }
                that.saveLoading=false;
            })
            .catch((fail)=>{
                that.saveLoading=false;
                that.$message.error("保存异常")
            })
        }


    },
    
  
}
</script>
<style lang="scss" scoped>


.tab-keys{
        position: relative;
    
        .save_role{
            display: block;
            text-align: center;
            border-radius: 25px;
            padding: 5px 10px;
            background: #eb9fa9;
            cursor: pointer;
            color: #fff;
            margin-right: 10px;

            &:hover{
                background-color: #e78d99;
            }
        }

        .setup_title:first-child{
            margin-top: 0;
        }
        .setup_title {
        
            border-radius: 4px;
            height: 24px;
            line-height: 24px;
            font-size: 18px;
            margin: 20px 10px;
            color:#eb9fa9;
            display:flex;
            align-items: center;
            i{
            
                display: inline-block;
                width:4px;
                background:#eb9fa9 ;
                height: 24px;
                border-radius: 5px;
                margin-right:10px
            }
            
        }
        .setup_content{
            margin: 10px;
            .setup_keybox {
                line-height: 32px;
                margin: 10px 0;
                overflow: hidden;

                .setup_keylable {
                    width: 50%;
                    float: left;

                }
                .setup_keyblock{
                    float: right;
                    width: 30%;
                    
                }
            }
            &.action .setup_keylable{
                cursor: pointer;
                &:hover{
                    color: #eb9fa9  ;
                }
            }
        }
    
    
}


</style>
